/**
 * SEO Configuration for RealFlame website
 * Centralized SEO data for all pages
 */

export const SITE_CONFIG = {
  name: "RealFlame",
  url: "https://realflame.co.in",
  logo: "https://realflame.co.in/android-chrome-512x512.png",
  supportEmail: "info@realflame.co.in",
  supportPhone: "+91 73107 77481",
  address: "Lucknow, Uttar Pradesh, India",
  twitter: "@RealFlameIndia",
};


export const PAGE_SEO = {
  home: {
    title: "RealFlame | Premium PNG Stoves & PNG-Compatible Stoves",
    description:
      "RealFlame is a leading PNG stove manufacturer producing high-performance PNG stoves engineered for modern households. Our premium PNG stoves are made specifically for PNG gas pipelines, offering energy efficiency, flame stability, and long-lasting durability with no LPG-to-PNG conversion required. Explore PNG-compatible 2-burner, 3-burner, and 4-burner stoves designed for modern kitchens across India.",
    keywords:
      "RealFlame, PNG Stove, PNG Stoves, PNG Stove Manufacturer, PNG-compatible stove, PNG compatible stove, 2 Burner PNG Stove, 3 Burner PNG Stove, 4 Burner PNG Stove, Glass Top PNG Stove, Stainless Steel PNG Stove, Buy PNG Stove Online India",
    canonical: "https://realflame.co.in/",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
  products: {
    title: "All Products | PNG Stoves & Accessories - RealFlame",
    description:
      "Explore RealFlame's complete catalog of PNG stoves, LPG gas stoves, burners, and kitchen accessories. Built for durability, safety, and energy efficiency.",
    keywords:
      "RealFlame Products, PNG Stove, LPG Stove, PNG Stove India, Kitchen Accessories, Buy PNG Stove",
    canonical: "https://realflame.co.in/products",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
  about: {
    title: "About Us | RealFlame - Premium PNG Stove Manufacturer",
    description:
      "Learn about RealFlame, India's trusted PNG stove manufacturer with ISO-certified production facilities dedicated to clean, efficient, and safe cooking solutions.",
    keywords:
      "About RealFlame, PNG Stove Manufacturer India, Kitchen Appliances Company, RealFlame History",
    canonical: "https://realflame.co.in/about",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
  contact: {
    title: "Contact Us | RealFlame PNG Stoves - Support & Enquiries",
    description:
      "Get in touch with RealFlame customer support for PNG stove enquiries, bulk orders, dealership opportunities, and product service across India.",
    keywords:
      "Contact RealFlame, PNG Stove Support, RealFlame Phone Number, RealFlame Email",
    canonical: "https://realflame.co.in/contact-us",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
  certifications: {
    title: "Certifications & Quality Standards | RealFlame",
    description:
      "View RealFlame's quality standards, safety testing procedures, and manufacturing compliance for PNG stoves and gas appliances.",
    keywords:
      "RealFlame Certifications, PNG Stove Quality, ISI Certified, BIS, Kitchen Safety Standards",
    canonical: "https://realflame.co.in/certifications",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
  gallery: {
    title: "Photo Gallery | RealFlame PNG Stoves",
    description:
      "View high-resolution photos of RealFlame PNG stoves, manufacturing processes, quality testing, and kitchen appliance designs.",
    keywords: "RealFlame Gallery, PNG Stove Photos, Kitchen Stove Images",
    canonical: "https://realflame.co.in/gallery",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
  clients: {
    title: "Our Clients | RealFlame - Trusted Partners",
    description:
      "Discover RealFlame's trusted commercial partners, distributors, and bulk supply clients across India.",
    keywords: "RealFlame Clients, PNG Stove Distributors, Business Partners India",
    canonical: "https://realflame.co.in/clients",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
  terms: {
    title: "Terms & Conditions | RealFlame",
    description:
      "Read RealFlame's terms and conditions regarding product purchases, 2-year warranty coverage, and website usage.",
    keywords: "RealFlame Terms, PNG Stove Warranty Terms, Purchase Conditions",
    canonical: "https://realflame.co.in/TermsAndConditions",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
  privacy: {
    title: "Privacy Policy | RealFlame",
    description:
      "Review RealFlame's privacy policy to understand how customer data is securely collected, used, and protected.",
    keywords: "RealFlame Privacy Policy, Data Protection, User Privacy",
    canonical: "https://realflame.co.in/PrivacyPolicy",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
  returns: {
    title: "Returns & Exchange Policy | RealFlame",
    description:
      "Information on RealFlame's returns, exchange guidelines, and customer service support for stove purchases.",
    keywords: "RealFlame Returns, PNG Stove Exchange, Return Policy India",
    canonical: "https://realflame.co.in/returns",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
  portfolio: {
    title: "Featured Highlights | RealFlame",
    description:
      "Explore RealFlame's featured highlights, newspaper clippings, and media coverage showcasing our PNG stove manufacturing journey.",
    keywords: "RealFlame Portfolio, Media Coverage, PNG Stove Press, RealFlame News",
    canonical: "https://realflame.co.in/portfolio",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
  usefulLinks: {
    title: "Watch & Shop | RealFlame PNG Stoves",
    description:
      "Watch RealFlame product videos and shop our range of PNG stoves and kitchen appliances directly online.",
    keywords: "Watch and Shop RealFlame, PNG Stove Video, Buy PNG Stove Online",
    canonical: "https://realflame.co.in/useful-links",
    ogImage: "https://realflame.co.in/android-chrome-512x512.png",
  },
};

/**
 * Generate dynamic SEO for product pages
 */
export function getProductSEO(product, selectedVariation) {
  if (!product) return PAGE_SEO.products;

  const productName = selectedVariation
    ? `${product.baseTitle} - ${selectedVariation.title}`
    : product.baseTitle;

  const rawDesc = selectedVariation?.description || product.baseDescription || "";
  const cleanedDesc = rawDesc.replace(/`/g, "").trim();

  let description = `${productName}: ${cleanedDesc}`;
  if (description.length < 110) {
    description += ` Premium quality by RealFlame with warranty, secure checkout, and doorstep delivery across India.`;
  }

  if (description.length > 160) {
    description = description.substring(0, 157) + "...";
  }

  const rawImage = selectedVariation?.images?.[0] || product.baseImage;
  let ogImage = "https://realflame.co.in/android-chrome-512x512.png";
  if (typeof rawImage === "string") {
    ogImage = rawImage.startsWith("http")
      ? rawImage
      : `https://realflame.co.in${rawImage.startsWith("/") ? "" : "/"}${rawImage}`;
  }

  const slug = product.id;
  const canonical = `https://realflame.co.in/product/${slug}`;

  const categoryKeyword = product.baseCategory === "png-stoves"
    ? "PNG Stove, PNG Stoves, PNG-Compatible Stove"
    : product.baseCategory === "lpg-stoves"
    ? "LPG Stove, LPG Stoves, Gas Stove"
    : "Kitchen Appliances, Stove Accessories, RealFlame";

  const keywords = `${productName}, ${categoryKeyword}, RealFlame, Buy PNG Stove Online India`;

  return {
    title: `${productName} | RealFlame`,
    description,
    keywords,
    canonical,
    ogImage,
    ogType: "product",
    price: selectedVariation?.price,
    mrp: selectedVariation?.mrp,
    rating: selectedVariation?.rating,
    reviews: selectedVariation?.reviews,
    sku: selectedVariation?.sku,
    availability: selectedVariation?.price === "Quote on Request" ? "OutOfStock" : "InStock",
    brand: "RealFlame",
    slug,
  };
}
